module.exports = __webpack_public_path__ + "img/u360.c931957b.png";